import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import {
  InvoiceModel,
  InvoiceStatusUpdateModel,
  PaymentHistoryModel
} from "./invoice.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";
import { DirectDebitFile } from "./direct-debit-file.model";
import { CostAndExpenseModel } from "../../cost-expenses/models/cost-expense.model";

@Injectable()
export class LegacyInvoiceService {
  constructor(private authService: AuthService, private http: Http) {}
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();

  public GetInvoiceList(
    input?: DataListModel,
    invoicemodel?: InvoiceModel
  ): Observable<IAPIResponse> {
    let getInvoiceUrl = WeGoConfig.API_GET_BOOKING_INVOICE_LIST_LEGACY;
    let queryString = this.authService.HandleAPIListInput(input);

    let queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);

    if (queryString) {
      getInvoiceUrl = getInvoiceUrl + "?" + queryString;
    }

    getInvoiceUrl =
      getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInvoiceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportInvoiceList(
    input?: DataListModel,
    invoicemodel?: InvoiceModel
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getInvoiceUrl =
      WeGoConfig.API_EXPORT_BOOKING_INVOICE_LIST_LEGACY + "?" + queryString;
    let queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);
    getInvoiceUrl =
      getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInvoiceUrl, options);
  }

  public DeleteInvoice(invoiceHashId: string): Observable<IAPIResponse> {
    let deleteInvoiceUrl =
      WeGoConfig.API_DELETE_INVOICE + "?invoiceHashId=" + invoiceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(deleteInvoiceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResendBookingInvoice(invoiceNumber: string): Observable<IAPIResponse> {
    let getInvoiceUrl =
      WeGoConfig.API_RESEND_BOOKING_INVOICE_LEGACY + "?invoiceNumber=" + invoiceNumber;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInvoiceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DownloadInvoice(invoiceNumber: string): any {
    let getInvoiceUrl =
      WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE_LEGACY +
      "?invoiceNumber=" +
      invoiceNumber;
    let headers = this.authService.GetHeader("application/pdf");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInvoiceUrl, options);
  }

  public DownloadInvoicePDF(invoiceNumber: string): Observable<IAPIResponse> {
    let getInvoiceUrl =
      WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF_LEGACY +
      "?invoiceNumber=" +
      invoiceNumber;

    let body = "";
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(getInvoiceUrl,body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDirectDebitFileList(
    input?: DataListModel,
    directdebitmodel?: DirectDebitFile
  ): Observable<IAPIResponse> {
    let getInvoiceUrl = WeGoConfig.API_GET_DIRECT_DEBIT_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    let queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);

    if (queryString) {
      getInvoiceUrl = getInvoiceUrl + "?" + queryString;
    }

    getInvoiceUrl =
      getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInvoiceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportDirectDebitFileList(
    input?: DataListModel,
    directdebitmodel?: DirectDebitFile
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getInvoiceUrl =
      WeGoConfig.API_EXPORT_DIRECT_DEBIT_LIST + "?" + queryString;
    let queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);
    getInvoiceUrl =
      getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInvoiceUrl, options);
  }

  public GetDirectDebitFile(
    format: string,
    invoicemodel?: InvoiceModel[]
  ): Observable<IAPIResponse> {
    let getInvoiceUrl =
      WeGoConfig.API_GET_DIRECTDEBIT + "?selectedFormat=" + format;

    let body = invoicemodel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(getInvoiceUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DownloadDirectDebitFile(
    input: string[],
    DirectDebitDate: string,
    SelectedFormat: string
  ): any {
    let getInvoiceUrl =
      WeGoConfig.API_CREATE_DIRECT_DEBIT_FOR_COMPANY +
      "?RequestedCollectionDate=" +
      DirectDebitDate +
      "&SelectedFormat=" +
      SelectedFormat;
    let body = input;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(getInvoiceUrl, body, options);
  }

  public ReCreateDirectDebitFile(directDebitFileHashId: string): any {
    let getInvoiceUrl =
      WeGoConfig.API_RECREATE_DIRECT_DEBIT_FOR_COMPANY +
      "?directDebitFileHashId=" +
      directDebitFileHashId;
    let body = "";
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(getInvoiceUrl, body, options);
  }

  public IsDirectDebitEnabled(): Observable<IAPIResponse> {
    let getDirectDebitFileConfigStatus =
      WeGoConfig.API_GET_IS_DIRECTDEBIT_ENABLED_LEGACY;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDirectDebitFileConfigStatus, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDriverList(
    InstancehashId: string,
    input?: DataListModel,
    CompanyHashId?: string
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_DRIVER_LIST_INVOICE;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl +
        "?" +
        queryString +
        "&instanceHashId= " +
        InstancehashId +
        "&companyHashId=" +
        CompanyHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationList(
    InstancehashId: string,
    input?: DataListModel,
    CompanyHashId?: string
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_ORGANIZATION_LIST_INVOICE;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl +
        "?" +
        queryString +
        "&instanceHashId= " +
        InstancehashId +
        "&companyHashId=" +
        CompanyHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateManualInvoice(
    invoiceModel: InvoiceModel,
    sendInvoice: boolean = false
  ): Observable<IAPIResponse> {
    let body = invoiceModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let updateManualInvoiceUrl =
      WeGoConfig.API_POST_MANUAL_INVOICE_LEGACY + "?sendInvoice=" + sendInvoice;

    return this.http
      .post(updateManualInvoiceUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInvoiceNumber(): Observable<IAPIResponse> {
    let getDirectDebitFileConfigStatus = WeGoConfig.API_GET_INVOICE_NUMBER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDirectDebitFileConfigStatus, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetManualInvoiceByHashId(
    invoiceHashId: string
  ): Observable<IAPIResponse> {
    let getInvoicedetailUrl =
      WeGoConfig.API_GET_INVOICE_BY_HASH + "?invoiceHashId=" + invoiceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInvoicedetailUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanyAddress(companyHashId: string): Observable<IAPIResponse> {
    let getDirectDebitFileConfigStatus =
      WeGoConfig.API_GET_COMPANY_ADDRESS + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDirectDebitFileConfigStatus, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDriverAddress(driverHashId: string): Observable<IAPIResponse> {
    let getDirectDebitFileConfigStatus =
      WeGoConfig.API_GET_DRIVER_ADDRESS + "?driverHashId=" + driverHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDirectDebitFileConfigStatus, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationAddress(
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getDirectDebitFileConfigStatus =
      WeGoConfig.API_GET_ORGANIZATION_ADDRESS +
      "?organizationHashId=" +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDirectDebitFileConfigStatus, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownBookingList(
    sharedVehicleDriverHashId: string,
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getCostTypeUrl: string;
    getCostTypeUrl = WeGoConfig.API_GET_DROPDOWN_MANUAL_INVOICE_BOOKING_LIST;
    getCostTypeUrl =
      getCostTypeUrl +
      "?sharedVehicleDriverHashId=" +
      sharedVehicleDriverHashId +
      "&organizationHashId=" +
      organizationHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public RemoveCostAndExpenses(
    costandExpensesHashId: string
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let postRemoveCostAndExpensesFromInvoice =
      WeGoConfig.API_POST_REMOVE_COSTANDEXPENSE_FROM_INVOICE +
      "?costAndExpenseHashId=" +
      costandExpensesHashId;

    return this.http
      .post(postRemoveCostAndExpensesFromInvoice, "", options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInvoicePaymentHistory(
    paymentHistoryModel: PaymentHistoryModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getPaymentHistoryListUrl = WeGoConfig.API_INVOICE_PAYMENT_HISTORY_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    let queryStringInvoiceHistoryModel = this.JQueryHelper.Param(
      paymentHistoryModel
    );

    if (queryString) {
      getPaymentHistoryListUrl = getPaymentHistoryListUrl + "?" + queryString;
    }

    getPaymentHistoryListUrl =
      getPaymentHistoryListUrl +
      "&" +
      decodeURIComponent(queryStringInvoiceHistoryModel);

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPaymentHistoryListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingInvoiceBasicDetails(
    invoiceHashId: string
  ): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_INVOICE_BASIC_DETAILS_LEGACY +
      "?invoiceHashId=" +
      invoiceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateCostAndExpenses(
    formData: FormData,
    moduleName: string
  ): Observable<IAPIResponse> {
    let Apiurl = "";
    if (moduleName == "INVOICE") {
      Apiurl = WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE_MANUALINVOICE;
    } else {
      Apiurl = WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE;
    }

    return Observable.create((observer: any) => {
      let url: string = Apiurl;
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      let header = this.authService.GetHeaderForFile();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            console.log(xhr.response);
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.status);
            //this.authService.HandleAPIError(xhr.response.status)
          }
        }
      };
      xhr.open("POST", url, true);
      for (let i = 0; i < header.length; i++) {
        xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
      }
      xhr.send(formData);
    });
  }

  public ExportInvoicePaymentHistory(
    paymentHistoryModel: PaymentHistoryModel,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let exportPaymentHistoryUrl = WeGoConfig.API_EXPORT_INVOICE_PAYMENT_HISTORY;

    let queryStringinvoicemodel = this.JQueryHelper.Param(paymentHistoryModel);
    exportPaymentHistoryUrl =
      exportPaymentHistoryUrl +
      "?" +
      decodeURIComponent(queryStringinvoicemodel);

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(exportPaymentHistoryUrl, options);
  }

  public UpdateDueDateForInvoice(
    invoiceHashId: string,
    updatedDueDate: string
  ) {
    let getUpdateDueDateUrl =
      WeGoConfig.API_GET_UPDATE_DUE_DATE_FOR_INVOICE_LEGACY +
      "?invoiceHashId=" +
      invoiceHashId +
      "&updatedDueDate=" +
      updatedDueDate;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUpdateDueDateUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateInvoiceStatus(
    invoiceStatusUpdateModel: InvoiceStatusUpdateModel
  ): Observable<IAPIResponse> {
    let getUpdateInvoiceStatusUrl = WeGoConfig.API_POST_UPDATE_INVOICE_STATUS_LEGACY;
    let body = invoiceStatusUpdateModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(getUpdateInvoiceStatusUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInvoiceReopenClosedReasons(
    invoiceStatus: string
  ): Observable<IAPIResponse> {
    let getCostTypeUrl: string;
    getCostTypeUrl =
      invoiceStatus == "CLOSED"
        ? WeGoConfig.API_GET_INVOICE_CLOSED_REASON_DROPDOWN_URL
        : WeGoConfig.API_GET_INVOICE_REOPEN_REASON_DROPDOWN_URL;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/models/legacy-invoice.service.ts